import { useWarehouses } from "../../api/warehouses.query";

interface WarehouseNameProps {
  warehouseId?: string;
}

export const WarehouseName = ({ warehouseId }: WarehouseNameProps) => {
  const { data: warehouses } = useWarehouses();
  
  if (!warehouseId) return <span>-</span>;
  
  const warehouse = warehouses?.items?.find(w => w.id === warehouseId);
  return <span>{warehouse?.name || "Unknown"}</span>;
};